/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-connection-grid-rows';
const prefix = `${moduleName}.${componentName}`;

export const transmittedLabel = `${prefix}.transmittedLabel`;
export const recievedLabel = `${prefix}.recievedLabel`;
export const timeoutsLabel = `${prefix}.timeoutsLabel`;
export const outOfOrdersLabel = `${prefix}.outOfOrdersLabel`;
export const retransmitsLabel = `${prefix}.retransmitsLabel`;

export const ENGLISH = {
    [transmittedLabel]: 'Transmitted',
    [recievedLabel]: 'Recieved',
    [timeoutsLabel]: 'Timeouts',
    [outOfOrdersLabel]: 'Out Of Orders',
    [retransmitsLabel]: 'Retransmits',
};
